import React from 'react'

import About from './About.jsx'

export default () => (
  <About id='about3'>
    未成年で女性でプログラムを書く人間が珍しがられていた時代のインタビュー記事です。
  </About>
)
